//LIBRERIE
import React from "react";
import { useTranslation } from "react-i18next";

//IMG
import agenziaImg from "../../../public/assets/images/altrePag/interni.jpg";

const AboutUsMain: React.FC = () => {

    const { t } = useTranslation();

    return(
        <>
            <p className="mb-2 sub-title">{t('aboutUsPage.subTitle')}</p>
            <h2 className="mb-3">{t('aboutUsPage.title')}</h2>
            <p dangerouslySetInnerHTML={{ __html: t('aboutUsPage.para1') as string }} />
            <p  className="mb-4" dangerouslySetInnerHTML={{ __html: t('aboutUsPage.para2') as string }} />
            <div className="row justify-content-center align-items-center">
                <div className="col-12 col-md-10 col-lg-6 col-xl-5 mb-4 mb-xl-0">
                    <img src={agenziaImg} className="img-fluid border-img" alt={`${t('aboutUsPage.imgAlt1')}`} />
                </div>
                <div className="col-12 col-lg-6 col-xl-7 d-flex flex-column justify-content-around">
                    <div className="mb-xl-2">
                        <h3>{t('aboutUsPage.title2')}</h3>
                        <p dangerouslySetInnerHTML={{ __html: t('aboutUsPage.para3') as string }} />
                        <p dangerouslySetInnerHTML={{ __html: t('aboutUsPage.para4') as string }} />
                    </div>
                    <div>
                        <h3>{t('aboutUsPage.title3')}</h3>
                        <p dangerouslySetInnerHTML={{ __html: t('aboutUsPage.para5') as string }} />
                        <p className="d-lg-none d-xl-block" dangerouslySetInnerHTML={{ __html: t('aboutUsPage.para6') as string }} />
                    </div>
                </div>
            </div>
        </>
    )
};
export default AboutUsMain;